import { FlexibleBlockBrickCode, FlexibleBlockProps, FlexibleBlockTemplateCode } from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils';
import { brickCommon } from './common';

export const getCodeBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateCode>[] => {
  const brickCode: FlexibleBlockBrickCode = {
    ...brickCommon,
    brickName: 'HTML/CSS Block',
    brickType: 'code',
    html: `
<div class="flex items-center justify-center p-5">
  <div class="text-center">
    <h2 class="text-2xl font-bold mb-4">Sales Distribution</h2>
    <div class="pie-chart mx-auto mb-4"></div>
    <div class="flex justify-center space-x-4">
      <div class="flex items-center">
        <div class="w-4 h-4 bg-green-500 mr-2"></div>
        <span>Product A - 40%</span>
      </div>
      <div class="flex items-center">
        <div class="w-4 h-4 bg-orange-500 mr-2"></div>
        <span>Product B - 30%</span>
      </div>
    </div>
    <div class="flex justify-center space-x-4">
      <div class="flex items-center">
        <div class="w-4 h-4 bg-red-500 mr-2"></div>
        <span>Product C - 20%</span>
      </div>
      <div class="flex items-center">
        <div class="w-4 h-4 bg-blue-500 mr-2"></div>
        <span>Product D - 10%</span>
      </div>
    </div>
  </div>
</div>`,
    style: `
.pie-chart {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: conic-gradient(
    #4CAF50 0% 40%,
    #FF9800 40% 70%,
    #F44336 70% 90%,
    #2196F3 90% 100%
  );
}`,
    script: '',
    switchable: false,
  };

  return [
    {
      title: 'HTML/CSS Block',
      template: {
        type: 'code',
        view: 'basic',
      },
      bricks: [{ ...brickCode, index: 0 }],
      wrapper: { ...getWrapperProps('custom'), showTitle: false, className: ['p-0'] },
      className: [],
      //colspan: 3,
    },
  ];
};
